/* eslint-disable no-undef */
import React, { Component } from 'react';
import './../sass/MainMenu.css';
import { Col } from 'reactstrap';
import Route from '../../route';
import { connect } from 'react-redux';
import { removeTokens } from '../../store/localStorage';
import history from '../../route/history';
import Strings from '../../../src/locale';
import config from '../../config.json';
import { LsacMainLogoIcon } from '../../constants/icon';
import { updateAllVendorsData } from './../../store/actions/SubscriberAction';
import {
    updateVendorId,
    getVendorInformation,
    getRolesPermissionInformation,
    setRolesPermissionInformation,
    updateRolesPermissionInformation,
    resetOnLogout,
    isVendorInfoUpdated,
    resetVendorInformationState
} from './../../store/actions/AuthenticationAction';
import { getAllProducts } from './../../store/actions/VendorManagementAction';

import {
    Dropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
    Nav,
    NavItem,
    NavLink
} from 'reactstrap';
import { Link } from 'react-router-dom';
import { COMMON, SCREEN_READER, SUBSCRIBER, LAWREADY } from '../../constants';
import { logout } from '../../authProvider';
import Modal from './../../common/modal/modal';
import {
    findAndUpdateActiveVendor,
    shouldShowLawReady,
    vendorHasOnlyLawReadyProduct,
    canAddStudent,
    downloadFile,
    isAdmin,
    checkLSACPlusGuidedJourney,
    navigateWithSetTimeout,
    getVendorIdAndName,
    isNonAdminVendor,
    vendorHasPadProduct
} from './../../helpers/commonHelper';
import configInstance from '../../configSingleton';

let unlisten;

/**
 * Head Menu UI component
 * @class MainMenu
 * @param {*} props - React Props.
 * @author Accion Labs
 * @example <MainMenu />
 */
class MainMenu extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isMenuOpen: false,
            account: this.props.account,
            currentMenu: history.location.pathname,
            current: 'myStudents',
            dropdownOpen: false,
            noVendorRolesConfirmationModalOpen: false,
            manageDropdownOpen: false,
            contentBuilderDropdownOpen: false,
            resourcesDropdownOpen: false
        };
        this.props = props;
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.account !== prevState.account) {
            return {
                account: nextProps.account,
                noVendorRolesConfirmationModalOpen:
                    nextProps.noVendorRolesConfirmationModalOpen
            };
        } else return null;
    }

    signout = () => {
        // Signout function for removig tokens and MSAL Instance
        removeTokens();
        logout();
        this.props.resetOnLogout();
        localStorage.removeItem('configHashValue');
    };

    noVendorRolesModalClose = () => {
        this.setState({ noVendorRolesConfirmationModalOpen: false });
        this.signout();
    };

    async componentDidMount() {
        let { VendorData, location } = this.props;
        // check if user details is available after login
        unlisten = history.listen((location, action) => {
            this.setState({ currentMenu: location.pathname });
        });

        // Deep link conditions : storeDeepLinkInfo function
        this.storeDeepLinkInfo(location, VendorData);
        if (
            !isAdmin(this.props.vendorRoleInfo.userRoles) &&
            !this.props.vendorRoles
        ) {
            let vendorIdAndName = getVendorIdAndName(
                this.props.vendorRoleInfo?.userRoles
            );
            vendorIdAndName && updateAllVendorsData(vendorIdAndName);
        }
        if (this.props.vendorRoleInfo?.userRoles) {
            this.props.getAllProducts();
        }
    }

    componentDidUpdate(prevProps) {
        let {
            VendorData,
            vendorId,
            location,
            getVendorInformation,
            vendorInfo,
            isVendorInfoUpdated,
            isVendorInfoUpdatedFromServer,
            resetVendorInformationState
        } = this.props;

        if (prevProps.vendorId !== vendorId) {
            if (isNonAdminVendor(vendorId)) {
                getVendorInformation(vendorId);
                isVendorInfoUpdated(false);
            } else if (vendorId === COMMON.admin) {
                resetVendorInformationState({ vendorId: COMMON.admin });
            }
        }
        if (
            prevProps.location &&
            prevProps.location.pathname !== location.pathname
        ) {
            // Deep link conditions : storeDeepLinkInfo function
            this.storeDeepLinkInfo(location, VendorData);

            // Add focus to active nav
            setTimeout(() => {
                document.querySelector('ul#app-menu li div button.active')
                    ? document
                          .querySelector('ul#app-menu li div button.active')
                          .focus()
                    : document.querySelector('ul#app-menu li a.active') &&
                      document.querySelector('ul#app-menu li a.active').focus();
            }, 300);
        }

        if (
            isVendorInfoUpdatedFromServer &&
            JSON.stringify(prevProps.vendorInfo) !== JSON.stringify(vendorInfo)
        ) {
            if (vendorInfo.statusCode && vendorInfo.statusCode !== 200) {
                navigateWithSetTimeout(
                    this.props.navigate,
                    Route.PAGE_NOT_FOUND
                );
            }
            if (vendorInfo?.products && isNonAdminVendor(vendorId)) {
                if (
                    vendorInfo.products.length == 1 &&
                    vendorInfo.products[0].productId == 'LSAC-LawReady-Program'
                ) {
                    this.props.navigate(Route.LAWREADY + '/' + vendorId);
                } else if (
                    checkLSACPlusGuidedJourney(vendorInfo, this.props.location)
                ) {
                    navigateWithSetTimeout(
                        this.props.navigate,
                        Route.PROGRAM + '/' + vendorId
                    );
                }
            }
        }
    }

    componentWillUnmount() {
        // Unregister all services
        unlisten && unlisten();
    }

    storeDeepLinkInfo = (location, VendorData) => {
        // Deep link conditions
        if (
            location &&
            location.pathname &&
            location.pathname.includes('content-library') &&
            location.pathname.split('content-library/')[1] !== ''
        ) {
            // COntent Library module
            this.setState({ current: 'contentLibrary' });
        } else if (
            isAdmin(this.props.vendorRoleInfo?.userRoles) &&
            location &&
            location.pathname &&
            location?.pathname === '/reporting'
        ) {
            // Reporting module
            this.setState({ current: 'reporting' });
        } else if (
            location &&
            location.pathname &&
            location.pathname.includes('offers') &&
            location.pathname.split('offers/')[1] !== ''
        ) {
            // Offers module
            this.setState({ current: 'offers' });
        } else if (
            this.props.vendorId &&
            this.props.vendorId === COMMON.admin &&
            this.props.location &&
            this.props.location.pathname &&
            this.props.location.pathname === '/vendors'
        ) {
            this.setState({ current: 'vendors' });
        } else if (
            location &&
            location.pathname &&
            location.pathname.includes('lawReady') &&
            location.pathname.split('lawReady/')[1] !== ''
        ) {
            // LawReady module
            this.setState({ current: 'lawReady' });
        } else if (
            location &&
            location.pathname &&
            location.pathname.includes('licencee-mark')
        ) {
            // resources module
            this.setState({ current: 'licencee-mark' });
        } else if (
            location &&
            location.pathname &&
            location.pathname.includes('content-builder')
        ) {
            // content builder
            this.setState({ current: 'contentBuilder' });
        } else if (
            location &&
            location.pathname &&
            location.pathname.includes('vendor')
        ) {
            // users
            this.setState({ current: 'users' });
        } else {
            // By default - Vendor's home module
            this.setState({ current: 'myStudents' });
        }
    };

    handleClick = (key) => {
        let { vendorId } = this.props;
        // menu item click, checks the key and route to the correct page.
        switch (key) {
            case 'myStudents':
                isNonAdminVendor(vendorId)
                    ? checkLSACPlusGuidedJourney(
                          this.props.vendorInfo,
                          this.props.location,
                          true
                      )
                        ? this.props.navigate(Route.PROGRAM + '/' + vendorId)
                        : vendorHasPadProduct(this.props.vendorInfo)
                          ? this.props.navigate(Route.PAD + '/' + vendorId)
                          : this.props.navigate(
                                Route.SUBSCRIBER + '/' + vendorId
                            )
                    : this.props.navigate(Route.ADMIN);
                break;
            case 'contentLibrary':
                this.props.navigate(Route.CONTENT_LIBRARY + '/' + vendorId);
                break;
            case 'reporting':
                this.props.navigate(Route.REPORTING);
                break;
            case 'offers':
                this.props.navigate(Route.OFFERS + '/' + vendorId);
                break;
            case 'vendors':
                this.props.navigate(Route.VENDOR_MANAGEMENT);
                break;
            case 'lawReady':
                isNonAdminVendor(vendorId) &&
                    this.props.navigate(Route.LAWREADY + '/' + vendorId, {
                        state: {
                            forcefullyRenderLawReady: true
                        }
                    });
                break;
            case COMMON.contentBuilder:
                this.props.navigate(Route.CONTENT_BUILDER);
                break;
            case 'users':
                this.props.navigate(
                    `${Route.VENDOR_DETAILS}/${vendorId}${Route.USER_DETAILS}`
                );
                break;
            case 'score-report':
                this.downloadReport();
                break;
            case 'licencee-mark':
                this.props.navigate(`/${vendorId}${Route.LICENCEE_MARK}`);
                break;
            default:
                break;
        }
        this.setState({ current: key });
    };

    downloadReport = () => {
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            downloadFile(
                null,
                'scoreDistributionReport.pdf',
                configInstance.getConfig()
                    ?.REACT_APP_SCORE_DISTRIBUTION_REPORT_URL
            );
        } else {
            window.open(
                configInstance.getConfig()
                    ?.REACT_APP_SCORE_DISTRIBUTION_REPORT_URL
            );
        }
    };

    shouldShowContentLibrary = () => {
        let { vendorInfo, vendorId } = this.props;

        let index =
            vendorInfo &&
            vendorInfo.products &&
            vendorInfo.products.findIndex(
                (product) => product.productId === 'LSAC-PLUS Program'
            );

        return (
            isNonAdminVendor(vendorId) &&
            index < 0 &&
            !vendorHasOnlyLawReadyProduct(vendorInfo)
        );
    };

    shouldShowResources = () => {
        let { vendorId } = this.props;
        return (
            isNonAdminVendor(vendorId) &&
            config.REACT_APP_FLAG_RESOURCES_FEATURE === 'true'
        );
    };

    shouldShowContentBuilder = () => {
        let { vendorRoleInfo } = this.props;

        let index =
            vendorRoleInfo &&
            vendorRoleInfo.userRoles &&
            vendorRoleInfo.userRoles.length > 0 &&
            vendorRoleInfo.userRoles.findIndex(
                (roleObj) => roleObj.role == 'LSAT-Admin'
            );

        return (
            configInstance.getConfig().REACT_APP_LSAT_ADMIN_FEATURE ===
                'true' && index >= 0
        );
    };

    /**
     * Function to check non Admin vendor have only lawReady product or not
     *
     * @param - vendorInfo - Vendor information
     * @param - vendorId - vendor id
     */
    vendorHasOnlyLawReadyProductAndNotAdmin = (vendorInfo, vendorId) => {
        if (vendorId === 'ADMIN') {
            return false;
        }
        if (vendorHasOnlyLawReadyProduct(vendorInfo)) {
            return true;
        }
        return false;
    };

    render() {
        let currentMenu = this.state.currentMenu;
        const userProfileMenuId = 'userProfileDropDownOptions',
            manageDropdown = 'manageDropdownOptions',
            contentBuilderDropdown = 'contentBuilderDropdownOptions',
            resourcesDropdown = 'resourcesDropdownOptions';

        return (
            <Col
                className="main-header-wrapper"
                data-testid="main-menu-wrapper"
            >
                <header
                    className={
                        'app-header ' +
                        (this.state.isMenuOpen ? 'menu-active' : '')
                    }
                    role="banner"
                >
                    <div className="logo">
                        <img
                            src={LsacMainLogoIcon}
                            alt={COMMON.lsacLogoAlt}
                            width="70"
                            height="53"
                        />
                    </div>

                    <Nav className="main-menu" pills id="app-menu">
                        <NavItem>
                            <Dropdown
                                data-testid="manage-dropdown-container"
                                className={`h-item dropdown-link ${
                                    currentMenu === Route.PROFILE_OVERVIEW
                                        ? 'active'
                                        : ''
                                }`}
                                isOpen={this.state.manageDropdownOpen}
                                toggle={() => {
                                    this.setState({
                                        manageDropdownOpen:
                                            !this.state.manageDropdownOpen
                                    });
                                }}
                                onKeyPress={(event) => {
                                    let code = event.keyCode || event.which;
                                    if (code == 13) {
                                        const firstDropdownItem =
                                            document.getElementById(
                                                'my-students-na'
                                            );
                                        if (
                                            firstDropdownItem &&
                                            firstDropdownItem.focus &&
                                            !this.state.manageDropdownOpen
                                        )
                                            firstDropdownItem.focus();
                                    }
                                }}
                            >
                                <DropdownToggle
                                    data-testid="manage-dropdown-toggle"
                                    aria-controls={manageDropdown}
                                    className={`manage-menu ${
                                        this.state.current === 'offers' ||
                                        this.state.current === 'myStudents' ||
                                        this.state.current === 'reporting'
                                            ? 'active'
                                            : 'inactive'
                                    }`}
                                    aria-current={
                                        this.state.current === 'myStudents' ||
                                        'offers'
                                            ? 'page'
                                            : ''
                                    }
                                >
                                    <span>{Strings.menu.manage}</span>
                                </DropdownToggle>
                                <DropdownMenu>
                                    <DropdownMenu
                                        className="offer-dropdown"
                                        tag="ul"
                                        id={manageDropdown}
                                        data-testid="manage-dropdown"
                                    >
                                        {!this.vendorHasOnlyLawReadyProductAndNotAdmin(
                                            this.props.vendorInfo,
                                            this.props.vendorId
                                        ) && (
                                            <DropdownItem
                                                key="myStudents"
                                                data-testid="my-students-nav"
                                                id={'my-students-na'}
                                                className={`menu-student ${
                                                    this.state.current ==
                                                    'myStudents'
                                                        ? 'active'
                                                        : 'inactive'
                                                }`}
                                                onClick={() => {
                                                    this.handleClick(
                                                        'myStudents'
                                                    );
                                                }}
                                                aria-current={
                                                    this.state.current ===
                                                    'myStudents'
                                                        ? 'page'
                                                        : ''
                                                }
                                            >
                                                {isNonAdminVendor(
                                                    this.props.vendorId
                                                )
                                                    ? Strings.menu.myStudents
                                                    : Strings.menu.allStudents}
                                            </DropdownItem>
                                        )}
                                        {configInstance.getConfig()
                                            .REACT_APP_SCORE_DISTRIBUTION_REPORT_FEATURE ===
                                            'true' &&
                                            !this.vendorHasOnlyLawReadyProductAndNotAdmin(
                                                this.props.vendorInfo,
                                                this.props.vendorId
                                            ) && (
                                                <DropdownItem
                                                    key="score-report"
                                                    data-testid="score-report-nav"
                                                    className={`menu-student ${
                                                        this.state.current ==
                                                        'score-report'
                                                            ? 'active'
                                                            : 'inactive'
                                                    }`}
                                                    onClick={() => {
                                                        this.handleClick(
                                                            'score-report'
                                                        );
                                                    }} // Download Score report
                                                >
                                                    {Strings.menu.scoreReport}
                                                </DropdownItem>
                                            )}
                                        {isNonAdminVendor(
                                            this.props.vendorId
                                        ) &&
                                            this.props.vendorInfo &&
                                            this.props.vendorInfo
                                                .allowedProductsForOffers &&
                                            this.props.vendorInfo
                                                .allowedProductsForOffers
                                                .length > 0 &&
                                            this.props.vendorInfo
                                                .maxOfferCount &&
                                            !vendorHasOnlyLawReadyProduct(
                                                this.props.vendorInfo
                                            ) && (
                                                <DropdownItem
                                                    key="offers"
                                                    data-testid="offers-nav"
                                                    className={`menu-student ${
                                                        this.state.current ==
                                                        'offers'
                                                            ? 'active'
                                                            : 'inactive'
                                                    }`}
                                                    onClick={() => {
                                                        this.handleClick(
                                                            'offers'
                                                        );
                                                    }} // switch to Vendor Offers page
                                                    aria-current={
                                                        this.state.current ===
                                                        'offers'
                                                            ? 'page'
                                                            : ''
                                                    }
                                                >
                                                    {Strings.menu.offers}
                                                </DropdownItem>
                                            )}
                                        {this.props?.vendorId ==
                                            COMMON.admin && (
                                            <DropdownItem
                                                key="vendors"
                                                data-testid="vendors-nav"
                                                className={`menu-student ${
                                                    this.state.current ==
                                                    'vendors'
                                                        ? 'active'
                                                        : 'inactive'
                                                }`}
                                                onClick={() => {
                                                    this.handleClick('vendors');
                                                }} // switch to Vendor Offers page
                                                aria-current={
                                                    this.state.current ===
                                                    'vendors'
                                                        ? 'page'
                                                        : ''
                                                }
                                            >
                                                {Strings.menu.vendors}
                                            </DropdownItem>
                                        )}
                                        {this.props?.vendorId ==
                                            COMMON.admin && (
                                            <DropdownItem
                                                key="reporting"
                                                data-testid="reporting-nav"
                                                className={`menu-student ${
                                                    this.state.current ==
                                                    'reporting'
                                                        ? 'active'
                                                        : 'inactive'
                                                }`}
                                                onClick={() => {
                                                    this.handleClick(
                                                        'reporting'
                                                    );
                                                }}
                                                aria-current={
                                                    this.state.current ===
                                                    'reporting'
                                                        ? 'page'
                                                        : ''
                                                }
                                            >
                                                {Strings.menu.reporting}
                                            </DropdownItem>
                                        )}
                                        {canAddStudent(
                                            this.props.vendorRoles,
                                            this.props.VendorData,
                                            this.props.vendorId
                                        ) &&
                                            !vendorHasOnlyLawReadyProduct(
                                                this.props.vendorInfo
                                            ) &&
                                            configInstance.getConfig()
                                                .REACT_APP_VENDOR_USER_FEATURE ===
                                                'true' && (
                                                <DropdownItem
                                                    key="users"
                                                    data-testid="users-nav"
                                                    className={`menu-student ${
                                                        this.state.current ==
                                                        'users'
                                                            ? 'active'
                                                            : 'inactive'
                                                    }`}
                                                    onClick={() => {
                                                        this.handleClick(
                                                            'users'
                                                        );
                                                    }} // switch to users page
                                                    aria-current={
                                                        this.state.current ===
                                                        'users'
                                                            ? 'page'
                                                            : ''
                                                    }
                                                >
                                                    {Strings.menu.users}
                                                </DropdownItem>
                                            )}
                                        {shouldShowLawReady(
                                            this.props.vendorInfo,
                                            this.props.vendorId
                                        ) && (
                                            <DropdownItem
                                                key="lawReady"
                                                data-testid="law-ready-nav"
                                                className={`menu-student ${
                                                    this.state.current ==
                                                    'lawReady'
                                                        ? 'active'
                                                        : 'inactive'
                                                }`}
                                                onClick={() => {
                                                    this.handleClick(
                                                        'lawReady'
                                                    );
                                                }}
                                                aria-current={
                                                    this.state.current ===
                                                    'lawReady'
                                                        ? 'page'
                                                        : ''
                                                }
                                            >
                                                {LAWREADY.lawReady}
                                            </DropdownItem>
                                        )}
                                    </DropdownMenu>
                                </DropdownMenu>
                            </Dropdown>
                        </NavItem>
                        {this.shouldShowContentLibrary() && (
                            <NavItem>
                                <NavLink
                                    href="javascript:void(0);"
                                    key="contentLibrary"
                                    data-testid="content-library-nav"
                                    className={`menu-student ${
                                        this.state.current == 'contentLibrary'
                                            ? 'active'
                                            : 'inactive'
                                    }`}
                                    onClick={() => {
                                        this.handleClick('contentLibrary');
                                    }}
                                    aria-current={
                                        this.state.current === 'contentLibrary'
                                            ? 'page'
                                            : ''
                                    }
                                >
                                    {Strings.menu.contentLibrary}
                                </NavLink>
                            </NavItem>
                        )}

                        {this.shouldShowResources() && (
                            <NavItem>
                                <Dropdown
                                    data-testid="resources-dropdown-container"
                                    className={`h-item dropdown-link resource-wrapper ${
                                        currentMenu === Route.PROFILE_OVERVIEW
                                            ? 'active'
                                            : ''
                                    }`}
                                    isOpen={this.state.resourcesDropdownOpen}
                                    toggle={() => {
                                        this.setState({
                                            resourcesDropdownOpen:
                                                !this.state
                                                    .resourcesDropdownOpen
                                        });
                                    }}
                                    onKeyPress={(event) => {
                                        let code = event.keyCode || event.which;
                                        if (code == 13) {
                                            const firstDropdownItem =
                                                document.getElementById(
                                                    'official-lsat-content-licensee-mark-nav'
                                                );
                                            if (
                                                firstDropdownItem &&
                                                firstDropdownItem.focus &&
                                                !this.state
                                                    .resourcesDropdownOpen
                                            )
                                                firstDropdownItem.focus();
                                        }
                                    }}
                                >
                                    <DropdownToggle
                                        data-testid="resources-dropdown-toggle"
                                        aria-controls={resourcesDropdown}
                                        className={`content-menu resources-menu ${
                                            this.state.current ===
                                            'licencee-mark'
                                                ? 'active'
                                                : 'inactive'
                                        }`}
                                        aria-current={
                                            this.state.current ===
                                            'licencee-mark'
                                                ? 'page'
                                                : ''
                                        }
                                    >
                                        <span>{Strings.menu.resources}</span>
                                    </DropdownToggle>
                                    <DropdownMenu
                                        className="offer-dropdown resources-dropdown"
                                        tag="ul"
                                        id={resourcesDropdown}
                                        data-testid="resources-dropdown"
                                    >
                                        {config.REACT_APP_FLAG_LICENSEE_MARK_FEATURE ===
                                            'true' && (
                                            <DropdownItem
                                                key="licencee-mark"
                                                data-testid="official-lsat-content-licensee-mark-nav"
                                                id="official-lsat-content-licensee-mark-nav"
                                                className={`menu-student ${
                                                    this.state.current ==
                                                    'licencee-mark'
                                                        ? 'active'
                                                        : 'inactive'
                                                }`}
                                                onClick={() => {
                                                    this.handleClick(
                                                        'licencee-mark'
                                                    );
                                                }}
                                                aria-current={
                                                    this.state.current ===
                                                    'licencee-mark'
                                                        ? 'page'
                                                        : ''
                                                }
                                            >
                                                {Strings.menu.licenceeMark}
                                            </DropdownItem>
                                        )}
                                    </DropdownMenu>
                                </Dropdown>
                            </NavItem>
                        )}

                        {this.shouldShowContentBuilder() && (
                            <NavItem>
                                <Dropdown
                                    data-testid="content-dropdown-container"
                                    className={`h-item dropdown-link ${
                                        currentMenu === Route.PROFILE_OVERVIEW
                                            ? 'active'
                                            : ''
                                    }`}
                                    isOpen={
                                        this.state.contentBuilderDropdownOpen
                                    }
                                    toggle={() => {
                                        this.setState({
                                            contentBuilderDropdownOpen:
                                                !this.state
                                                    .contentBuilderDropdownOpen
                                        });
                                    }}
                                    onKeyPress={(event) => {
                                        let code = event.keyCode || event.which;
                                        if (code == 13) {
                                            const firstDropdownItem =
                                                document.getElementById(
                                                    'content-builder-nav'
                                                );
                                            if (
                                                firstDropdownItem &&
                                                firstDropdownItem.focus &&
                                                !this.state
                                                    .contentBuilderDropdownOpen
                                            )
                                                firstDropdownItem.focus();
                                        }
                                    }}
                                >
                                    <DropdownToggle
                                        data-testid="content-dropdown-toggle"
                                        aria-controls={contentBuilderDropdown}
                                        className={`content-menu ${
                                            this.state.current ===
                                            COMMON.contentBuilder
                                                ? 'active'
                                                : 'inactive'
                                        }`}
                                        aria-current={
                                            this.state.current ===
                                            'contentBuilder'
                                                ? 'page'
                                                : ''
                                        }
                                    >
                                        <span>
                                            {Strings.menu.contentBuilder}
                                        </span>
                                    </DropdownToggle>
                                    <DropdownMenu
                                        className="content-dropdown"
                                        tag="ul"
                                        id={contentBuilderDropdown}
                                        data-testid="content-dropdown"
                                    >
                                        <DropdownItem
                                            className={`menu-student ${
                                                this.state.current ==
                                                COMMON.contentBuilder
                                                    ? 'active'
                                                    : 'inactive'
                                            }`}
                                            onClick={() => {
                                                this.handleClick(
                                                    COMMON.contentBuilder
                                                );
                                            }}
                                            data-testid="content-builder-nav"
                                            id="content-builder-nav"
                                        >
                                            {COMMON.lsatAdmin}
                                        </DropdownItem>
                                    </DropdownMenu>
                                </Dropdown>
                            </NavItem>
                        )}
                    </Nav>
                    <div className="user-info">
                        <div className="user-info-wrapper">
                            <Dropdown
                                data-testid="userinfo-dropdown-container"
                                className={`h-item dropdown-link ${
                                    currentMenu === Route.PROFILE_OVERVIEW
                                        ? 'active'
                                        : ''
                                }`}
                                isOpen={this.state.dropdownOpen}
                                toggle={() => {
                                    this.setState({
                                        dropdownOpen: !this.state.dropdownOpen
                                    });
                                }}
                                onKeyPress={(event) => {
                                    let code = event.keyCode || event.which;
                                    if (code == 13) {
                                        const firstDropdownItem =
                                            document.getElementById(
                                                'logout-button'
                                            );
                                        if (
                                            firstDropdownItem &&
                                            firstDropdownItem.focus &&
                                            !this.state.dropdownOpen
                                        )
                                            firstDropdownItem.focus();
                                    }
                                }}
                            >
                                <DropdownToggle
                                    data-testid="userinfo-dropdown-toggle"
                                    aria-controls={userProfileMenuId}
                                >
                                    <span className="welcome">
                                        {Strings.menu.welcome}
                                        <span className="user-name">
                                            {this.state.account &&
                                            this.state.account.name
                                                ? `${this.state.account.name}`
                                                : Strings.menu.newUser}
                                        </span>
                                    </span>
                                </DropdownToggle>
                                <DropdownMenu
                                    className={
                                        this.state.dropdownOpen
                                            ? 'showMenu'
                                            : ''
                                    }
                                    tag="ul"
                                    id={userProfileMenuId}
                                    data-testid="userinfo-dropdown"
                                >
                                    <DropdownItem
                                        data-testid="logout-button"
                                        id="logout-button"
                                        onClick={this.signout}
                                    >
                                        <Link
                                            className="dropdown-item-link"
                                            to={Route.SUBSCRIBER}
                                            aria-label={
                                                SCREEN_READER.menu.logout
                                            }
                                        >
                                            {Strings.menu.logout}
                                        </Link>
                                    </DropdownItem>
                                </DropdownMenu>
                            </Dropdown>
                        </div>
                    </div>
                </header>

                <Modal
                    deactivateModal={this.noVendorRolesModalClose}
                    modalActive={this.state.noVendorRolesConfirmationModalOpen}
                    modal_generic_btn
                    dialogClass={'ant-modal alert-custom-modal'}
                    expandedContent={
                        <div className="modal-layout">
                            <h2
                                className="title center-align"
                                data-testid="no-vendor-roles-title"
                            >
                                {SUBSCRIBER.noVendorRoles}
                            </h2>
                            <div className="Background-opacity"></div>
                            <div className="flex flex-column flex-center vendor-role-body">
                                <div>
                                    {SUBSCRIBER.noVendorRolesMessage1}
                                    <span className="spacer blue">
                                        {this.state.account &&
                                            this.state.account?.username}
                                    </span>
                                    {SUBSCRIBER.noVendorRolesMessage2}
                                </div>
                                <span>{SUBSCRIBER.noVendorRolesMessage3}</span>
                            </div>
                        </div>
                    }
                    onYesClick={this.noVendorRolesModalClose}
                    btnTtl={'OK'}
                />
            </Col>
        );
    }
}

/**
 *
 * Redux map dispatch to props method
 *
 */
const mapDispatchToProps = {
    updateAllVendorsData,
    updateVendorId,
    getVendorInformation,
    getRolesPermissionInformation,
    setRolesPermissionInformation,
    updateRolesPermissionInformation,
    resetOnLogout,
    getAllProducts,
    isVendorInfoUpdated,
    resetVendorInformationState
};

const mapStateToProps = (state) => {
    return {
        account: state.authenticationReducer.account,
        vendorId: state.authenticationReducer.vendorId,
        VendorData: state.authenticationReducer.VendorData,
        showAddSubscriberByDefault:
            state.subscriberReducer.showAddSubscriberByDefault,
        showResendInviteByDefault:
            state.subscriberReducer.showResendInviteByDefault,
        addStudentConfirmationModalOpen:
            state.subscriberReducer.addStudentConfirmationModalOpen,
        vendorRoles: state.subscriberReducer.vendorRoles,
        vendorInfo: state.authenticationReducer.vendorInfo,
        vendorRoleInfo: state.authenticationReducer.vendorRoleInfo,
        vendorAADData: state.authenticationReducer.vendorAADData,
        configValue: state.authenticationReducer.configValue,
        isVendorInfoUpdatedFromServer:
            state.authenticationReducer.isVendorInfoUpdatedFromServer
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(MainMenu);
